<style lang="scss" scoped>
.report_wrap{
  height: 100%;
}
.time-wrap {
    text-align: right;
    margin-right: 16px;
    span{
        color: #74D9FF;
    }
}
#line-wrap {
  position: relative;
  width: 100%;
  height: 300px;
}
.ivu-table-wrapper {
  margin-top: 26px;
  margin-bottom: 46px;
}
.table-wrap {
  width: auto;
  margin: 15px 0;
}
.col-wraps {
  .c-top {
    width: 100%;
    height: 44px;
    background:  #001a29;
    text-align: center;
    line-height: 44px;
    cursor: pointer;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    border-color: rgba(8,244,247,.3);
    background-color: hsla(0,0%,100%,.1);
  }
  .c-bot {
    width: 100%;
    height: 44px;
    text-align: center;
    line-height: 44px;
    cursor: pointer;
  }
}
.data-img {
  display: none;
  margin-left: 4px;
}
.col-wraps:hover {
  color:#74D9FF;
  .data-img {
    display: inline-block;
  }
}
.arrow-left {
  color: #57a3f3;
}
.arrow-right {
  color: #57a3f3;
}
.actived {
  color: #74D9FF;
}
.row-wraps {
  position: relative;
  color: rgba(116, 217, 255, 0.6);
}
.arrow-wrap {
  margin-top: 10px;
  position: relative;
  .arrow-right {
    position: absolute;
    z-index: 1;
    right: 2px;
    font-size: 18px;
    cursor: pointer;
  }
  .arrow-left {
    position: absolute;
    z-index: 1;
    left: 2px;
    font-size: 18px;
    cursor: pointer;
  }
}
.no-results {
  text-align: center;
  line-height: 100px;
  font-size: 14px;
  color: #74D9FF;
}
.aaaa{
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}
/deep/ .ivu-table{
    background-color: hsla(0,0%,100%,.1)!important;
    th{
        border: 0px !important;
    }
    td {
        background-color: #041936;
        transition: background-color .2s ease-in-out;
        color: #E4EFF5;
    }
}
/deep/ .ivu-table:before {
    content: "";
    position: absolute;
    background-color: #041936 !important;
}

/deep/ .ivu-table-header thead tr th{
    background-color: #0C2745;
    color: #7DB4DB;
}
.loading{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%; 
  height: 100%;
  padding-top: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,.3);
  img{
    width: 200px;
  }
}
</style>
<template>
<div class="report_wrap">
   <div class="no-results" v-if="noData">未查询到该设备的排查记录</div>
   <div class="loading" v-show="loading_status">
        <!-- 加载动画 -->
        <div class="loading_box" v-show="!dataResult.length">
            <img :src="tableLoad" />
        </div>
        <div class="more_data_box" v-show="dataResult.length">
            <img :src="tableMore" />
        </div>
    </div>
   <div v-if="resultOnOff">
    <div class="time-wrap">
      <span>刷新时间：</span>
      <span>{{currentDate}}</span>
      <Button type="primary" @click="refresh">刷新</Button>
    </div>
    <div class="arrow-wrap">
      <Icon @click="prev" v-if="newData.length > 8 && prevOnOff" class="arrow-left" type="md-arrow-round-back" />
      <Icon @click="next" v-if="newData.length > 8 && nextOnOff" class="arrow-right" type="md-arrow-round-forward" />
    </div>
    <div class="table-wrap">
      <Row class="row-wraps">

        <i-Col class="col-wraps" :span=24/showNewData.length v-for="(item, index) of showNewData" :key="index">
          <div
            class="c-top"
            :title="item.standardName"
            :class="[item._id == currentId ? 'actived':'']"
            @click="changeEvent(index, item._id, item.standardName)"
          >{{item.standardName}} </div>

          <div
            class="c-bot"
            :title="item.value"
            :class="[item._id == currentId ? 'actived':'']"
            @click="changeEvent(index, item._id, item.standardName)"
          >{{item.value}}
          <img class="data-img" src="http://gd-ca.oss-cn-beijing.aliyuncs.com/cdm/icon/quxian.png"/>
          </div>
        </i-Col>
      </Row>
    </div>
    <div id="line-wrap"></div>
    <template>
        <Table :columns="columnsResult" :data="dataResult"></Table>
    </template>
  </div>
</div>

</template>
<script>
let echarts = require("echarts/lib/echarts");
require("echarts/lib/chart/line");
require("echarts/lib/chart/bar");
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
require("echarts/lib/component/legend");
require("echarts/lib/component/dataZoom");
import tableLoad from '@/assets/img/animation.gif';
import tableMore from '@/assets/img/animation.gif';
export default {
  name: "comm-record",
  data() {
    return {
      loading_status: false,
      tableLoad,
      tableMore,
      resultOnOff: false,
      noData: false,
      currentDate: "",
      currentIndex: 0,
      currentType: "",
      currentId: "",
      i: 0,
      j: 8,
      currentTitle: "",
      newData: [],
      showNewData: [],
      nextOnOff: true,
      prevOnOff: false,
      zhexianData: [],
      seriesData: [],
      dangerSeriesData: [],
      xAxis: [],
      columnsResult: [
        {
          title: "排查项名称",
          key: "standardName"
        },
        {
          title: "排查时间",
          key: "recordTime",
          render: (h, params) => {
            let arr = [
              h(
                "span",
                {},
                `${this.timestampToTime(
                  this.dataResult[params.index].recordTime
                )}`
              )
            ];
            return h("div", arr);
          }
        },
        {
          title: "排查人",
          key: "patrolName"
        },
        {
          title: "排查值",
          key: "value"
        },
        {
          title: "是否隐患",
          key: "hiddenDanger",
          render: (h, params) => {
            let arr = [
              h("img", {
                attrs: {
                  src: `${this.dangerTrans(
                    this.dataResult[params.index].hiddenDanger
                  )}`
                }
              })
            ];
            return h("div", arr);
          }
        }
      ],
      dataResult: []
    };
  },
  props: ["type","deviceId"],
  mounted() {
    //this.currentType = this.$route.params.type;
    console.log(this.deviceId + "------设备id");
    this.onsize();
    this.getNewData();
    this.currentDate = this.timestampToTime(new Date());
  },
  methods: {
    refresh() {
      // 刷新
      this.currentDate = this.timestampToTime(new Date());
      (this.i = 0),
        (this.j = 8),
        (this.nextOnOff = true),
        (this.prevOnOff = false),
        this.getNewData();
    },
    changeEvent(index, id, name) {
      this.currentIndex = index;
      this.currentId = id;
      this.currentTitle = name;
      this.getZheXianData(this.currentId);
    },
    prev() {
      // 上一个
      this.i--;
      this.j--;
      let len = this.newData.length - 8;
      if (this.i > 0 || this.i == 0) {
        this.nextOnOff = true;
        this.showNewData = JSON.parse(
          JSON.stringify(this.newData.slice(this.i, this.j))
        );
        if (this.i == 0) {
          this.prevOnOff = false;
        }
      }
    },
    next() {
      // 下一个
      this.i++;
      this.j++;
      let len = this.newData.length - 8;
      if (this.i < len || this.i == len) {
        this.prevOnOff = true;
        this.showNewData = JSON.parse(
          JSON.stringify(this.newData.slice(this.i, this.j))
        );
        if (this.i == len) {
          this.nextOnOff = false;
        }
      } else {
        this.nextOnOff = false;
      }
    },
      // 获取折线图数据
    getZheXianData(id) {
        let url='mcbw/patrol_records/values';
        var data = {
            type: 'get',
            url: url,
            obj: {
                deviceId:this.deviceId,
                standardId: id,
                pageSize: 1000,
                currentPage: 1
            }
        };
        this.$Axios(data).then((res) => {
            if (res.data.success) {
                if (res.data.data) {
                    this.zhexianData = res.data.data;
                    this.dataResult = res.data.data;
                    this.manageZheData();
                }

            }
        });
    },
    manageZheData() {
      // 处理折线图数据
      this.xAxis = [];
      this.seriesData = [];
      this.dangerSeriesData = [];
      let username = [];
      let patrolName = [];
      let danger = [];

      this.zhexianData.forEach(item => {
        let time = this.timestampToTime(item.recordTime);
        this.xAxis.push(time);
        username.push(item.patrolName);
        patrolName.push(item.value);
        let dangerImaUrl = this.dangerTrans(item.hiddenDanger);
        danger.push(dangerImaUrl);
        if (item.hiddenDanger == 1) {
          this.dangerSeriesData.push(item.value);
        } else {
          this.dangerSeriesData.push(0);
        }
      });
      for (
        var i = 0;
        i < username.length && i < patrolName.length && i < danger.length;
        i++
      ) {
        this.seriesData[i] = {
          value: patrolName[i],
          tooltip: {
            formatter: `{b}<br/>排查人：${username[i]}<br/>排查值：${
              patrolName[i]
            }<br/>是否隐患：<img src="${danger[i]}"/>`
          }
        };
      }
      this.echartInit();
    },

    getNewData() {
        this.resultOnOff = false;
        this.noData = false;
        this.loading_status = true;
        let url='mcbw/patrol_records/current';
        var data = {
            type: 'get',
            url: url,
            obj: {
                patrolStandardType:this.type,
                deviceId:this.deviceId
            }
        };
        this.$Axios(data).then((res) => {
            this.loading_status = false;
            if (res.data.success) {
                if (res.data.data) {
                    this.newData = res.data.data;
                    if (this.newData.length != 0) {
                        this.$nextTick(()=>{
                            $JQ('.video-scroll').mCustomScrollbar({
                                callbacks: {
                                    onTotalScroll: function () {
                                    }
                                }
                            });
                        });
                        if (this.newData.length < 8 || this.newData.length == 8) {
                            this.showNewData = JSON.parse(JSON.stringify(this.newData));
                        } else {
                            this.showNewData = JSON.parse(
                                JSON.stringify(this.newData.slice(0, 8))
                            );
                        }
                        this.resultOnOff = true;
                        this.noData = false;

                    } else {
                        this.resultOnOff = false;
                        this.noData = true;
                    }
                    if (this.newData.length > 0) {
                        this.currentId = this.newData[0]["_id"];
                        this.currentTitle = this.newData[0]["standardName"];
                        this.getZheXianData(this.currentId);
                    }
                }
            }else {
              this.noData = true;
            }
        });
    },
    echartInit() {
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById("line-wrap"));
      // 指定图表的配置项和数据
      var option = {
        title: {
          text: `${this.currentTitle}趋势`,
          textStyle: {
            fontSize: 16, //字体大小
            color: "#74D9FF", // 字体颜色
            fontWeight: "normal"
          }
        },

        tooltip: {},
        grid: {
          left: "3%",
          right: "4%",
          bottom: "50px",
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: this.xAxis,
          axisTick: {
            show: false
          },
          axisLine:{
                lineStyle:{
                    color:'#74D9FF',
                }
            }
        },
        yAxis: [
          {
            type: "value",
            name: "单位（℃）",
              //设置坐标轴字体颜色
              axisLabel: {
                  show: true,
                  textStyle: {
                      color: '#74D9FF',
                      fontSize : 14
                  }
              },
              //设置坐标轴颜色
              axisLine:{
                  lineStyle:{
                      color:'#74D9FF'
                  }
              },
              splitLine: {
                  show: true,
                  lineStyle:{
                      color: ['#74D9FF'],
                      width: 1,
                      type: 'dotted'
                  }
              }
          },
          {
            type: "value",
            show: false,
            name: "单位（℃）",
              //设置坐标轴字体颜色
              axisLabel: {
                  show: true,
                  textStyle: {
                      color: '#74D9FF',
                      fontSize : 14
                  }
              },
              //设置坐标轴颜色
              axisLine:{
                  lineStyle:{
                      color:'#74D9FF'
                  }
              },
              splitLine: {
                  show: true,
                  lineStyle:{
                      color: ['#74D9FF'],
                      width: 1,
                      type: 'dotted'
                  }
              }
          }
        ],
        series: [
          {
            type: "bar",
            barWidth: 12,
            data: this.dangerSeriesData,
            itemStyle: {
              normal: {
                color: "#1890FF"
              }
            }
          },
          {
            type: "line",
            data: this.seriesData,
            itemStyle: {
              normal: {
                color: "#74D9FF",
                lineStyle: {
                  color: "#2FC25B"
                }
              }
            }
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    dangerTrans(val) {
      if (val == 1) {
        return "http://gd-ca.oss-cn-beijing.aliyuncs.com/cdm/icon/baojing.png";
      } else if (val == 0) {
        return "http://gd-ca.oss-cn-beijing.aliyuncs.com/cdm/icon/zhengchang.png";
      }
    },
    timestampToTime(timestamp) {
      // 转换时间戳
      if (timestamp == null) {
        return "";
      } else {
        var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + "-";
        var M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        var D = date.getDate() + " ";
        var h = date.getHours() + ":";
        var m = date.getMinutes() + ":";
        var s = date.getSeconds();
        return Y + M + D + h + m + s;
      }
    },
    onsize() {
      window.addEventListener("resize", function() {
        if (document.getElementById("line-wrap")) {
          echarts.init(document.getElementById("line-wrap")).resize();
        }
      });
    }
  },
  components: {}
};
</script>



// WEBPACK FOOTER //
// src/components/riskRecord/comm-record.vue